'use client'

import { Box, Link, styled } from '@mui/material'

export const TitleWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(1.2),
}))

export const SubMenuItemTitleLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 'bold',
  display: '-webkit-box',
  overflow: 'hidden',
  whiteSpace: 'normal',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  textOverflow: 'ellipsis',
  alignSelf: 'end',
})) as typeof Link
